module.exports = __webpack_public_path__ + "img/fi-rr-apps.3c7473b4.svg";